var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"g-sns-button",class:{
    'g-sns-button--border': _vm.border,
    'g-sns-button--transparent': _vm.transparent,
  },attrs:{"href":_vm.url,"target":"_blank"}},[_c('span',{staticClass:"g-sns-button__icon",class:( _obj = {}, _obj['g-sns-button__icon--'+_vm.sns] = _vm.sns, _obj['g-sns-button__icon--'+_vm.sns+'--'+_vm.color] = _vm.color, _obj )})])}
var staticRenderFns = []

export { render, staticRenderFns }